import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, share, switchMap } from 'rxjs';
import * as SharedActions from '@states/shared/shared.actions';
import { OrgVariablesService } from '../../development/org-variables.service';
import { TranslateService } from '@ngx-translate/core';
import { OrgVariablesActions } from '@states/org-variables/org-variables.action-types';
import { UtilsService } from '../../edge/utils.service';

@Injectable()
export class OrgVariablesEffects {
  public getVariables = createEffect(() =>
    this.actions$.pipe(
      ofType(OrgVariablesActions.getOrgVariables),
      mergeMap(() => {
        return this.alertVariablesService.getVariables().pipe(
          switchMap((res) => {
            return [
              OrgVariablesActions.getOrgVariablesSuccess({ variables: res }),
              OrgVariablesActions.setIsLoading({ isLoading: false }),
            ];
          }),
          catchError((response) => {
            return [OrgVariablesActions.setIsLoading({ isLoading: false }), this.catchError(response)];
          }),
        );
      }),
      share(),
    ),
  );

  public createVariable$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrgVariablesActions.addVariable),
      mergeMap(({ variable }) => {
        return this.alertVariablesService.createVariables(variable).pipe(
          switchMap((variable) => {
            return [
              SharedActions.showMessage({
                success: this.translateService.instant('TOASTS.ORG_VARIABLE_ADDED_SUCCESS'),
              }),
              OrgVariablesActions.addVariablesSuccess({ variable }),
              OrgVariablesActions.setIsLoading({ isLoading: false }),
            ];
          }),
          catchError((response) => {
            return [OrgVariablesActions.setIsLoading({ isLoading: false }), this.catchError(response)];
          }),
        );
      }),
      share(),
    ),
  );

  public updateVariable$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrgVariablesActions.editVariable),
      mergeMap(({ variable }) => {
        return this.alertVariablesService.updateVariables(variable).pipe(
          switchMap((variable) => {
            return [
              SharedActions.showMessage({
                success: this.translateService.instant('TOASTS.ORG_VARIABLE_UPDATED_SUCCESS'),
              }),
              OrgVariablesActions.editVariablesSuccess({ variable }),
              OrgVariablesActions.setIsLoading({ isLoading: false }),
            ];
          }),
          catchError((response) => {
            return [OrgVariablesActions.setIsLoading({ isLoading: false }), this.catchError(response)];
          }),
        );
      }),
      share(),
    ),
  );

  public removeVariable$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrgVariablesActions.removeVariable),
      mergeMap(({ name }) => {
        return this.alertVariablesService.removeVariable(name).pipe(
          switchMap(() => {
            return [
              SharedActions.showMessage({
                success: this.translateService.instant('TOASTS.ORG_VARIABLE_DELETED_SUCCESS'),
              }),
              OrgVariablesActions.removeVariablesSuccess({ name }),
              OrgVariablesActions.setIsLoading({ isLoading: false }),
            ];
          }),
          catchError((response) => {
            return [OrgVariablesActions.setIsLoading({ isLoading: false }), this.catchError(response)];
          }),
        );
      }),
      share(),
    ),
  );

  constructor(
    private actions$: Actions,
    private alertVariablesService: OrgVariablesService,
    private translateService: TranslateService,
    private utilsService: UtilsService,
  ) {}

  private catchError(response) {
    const message = this.utilsService.errMessage(response);
    return SharedActions.showMessage({ error: message });  }
}
